import React, { useState, useEffect } from 'react';

import { connect } from 'react-redux';
import classnames from 'classnames';

import './index.scss';

const HeaderDocuments = ({ documents }) => {
  const [isOpen, setIsOpen] = useState(false);

  const closePopper = () => setIsOpen(false);

  const onDocumentSelect = (documentULR) => {
    setIsOpen(false);
    if (!documentULR) return;

    window.open(documentULR, '_blank', 'noopener,noreferrer');
  };

  const ignoreEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    window.addEventListener('mouseup', closePopper, false);
    window.addEventListener('touchstart', closePopper, false);

    return () => {
      window.removeEventListener('mouseup', closePopper, false);
      window.removeEventListener('touchstart', closePopper, false);
    };
  });

  return (
    <div
      className="header-category"
      onClick={() => setIsOpen(!isOpen)}
      onMouseUp={ignoreEvent}
      onTouchStart={ignoreEvent}
    >
      <div className="documents-dropdown">
        <span>Files</span>
        <i className="fa fa-arrow-down"></i>
      </div>
      <div className={classnames('documents-popper', { show: isOpen })}>
        <ul>
          {documents.map((document, i) => {
            return (
              <li key={`header_document_item_${i}`} onClick={() => onDocumentSelect(document.url)}>
                {document.filename}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default connect(null)(HeaderDocuments);
